import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class GraphicsLayer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            graphicsLayer: null
        };
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules(['esri/layers/GraphicsLayer']).then(([GraphicsLayer]) => {
            let graphicsLayer = new GraphicsLayer({
                title: this.props.title ? this.props.title : '',
                id: this.props.id,
                listMode: this.props.listMode ? this.props.listMode : 'show',
            });

            this.props.map.add(graphicsLayer, this.props.index ? this.props.index : 0);
            this.setState({graphicsLayer});

        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.map.remove(this.state.graphicsLayer);
    }
}
